import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import vuescroll from "vuescroll/dist/vuescroll-native";
import "vuescroll/dist/vuescroll.css";

Vue.use(vuescroll);
Vue.config.productionTip = false

Vue.prototype.axios = axios
Vue.prototype.axios.defaults.baseURL = 'https://api.epark.online'
Vue.prototype.moment = moment;

Vue.filter('finance', function (value) {
    let float = parseFloat(value).toFixed(2)
    let str = float.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    if (float < 0) {
        str = "(" + str.slice(1) + ")"
    }
    return str
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
